import React from 'react'
import { Slider as AntdSlider } from 'antd'
import styled from 'styled-components'
import Flex from 'components/Flex'

const SliderStyle = styled(AntdSlider)`
  .ant-slider-rail {
    height: 2px;
  }
  .ant-slider-track {
    height: 2px;
  }
`

const Slider = ({
  value,
  onChange,
  marks,
  defaultValue,
  min,
  max,
  step,
  label,
  range,
  onAfterChange,
}) => {
  return (
    <Flex column>
      <SliderStyle
        value={value}
        range={range}
        onChange={onChange}
        marks={marks}
        defaultValue={defaultValue}
        min={min}
        max={max}
        onAfterChange={onAfterChange}
        step={step}
      />
      <Flex spaceBetween>
        <div>{min + ' ' + label} </div>
        <div>{max + ' ' + label}</div>
      </Flex>
    </Flex>
  )
}
export default Slider
